interface Props { title: string }

export default function PlaceholderPage({ title }: Props) {
  return (
    <div>
      <h1 style={{ font: '600 26px Lora,serif', color: '#1B2A4A', marginBottom: 8 }}>{title}</h1>
      <p style={{ font: '400 14px Inter,sans-serif', color: 'rgba(27,42,74,0.5)' }}>
        This section will be available in Phase 2.
      </p>
    </div>
  )
}
